import { useEffect } from 'react';
import cookie, { CookieSerializeOptions } from 'cookie';
import jstz from 'jstz';

import { USER_TIME_ZONE } from 'constants/constants';
import { NodeEnv } from 'constants/enums';
import { Logger } from 'lib/logger';

export const getCookieByName = (name: string): string => {
  if (typeof document === 'object') {
    return document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)?.pop() || '';
  }

  return '';
};

export const useStoreClientTimezone = () => {
  useEffect(() => {
    try {
      const cookieObject = cookie.parse(document.cookie);
      const userTimeZone = cookieObject[USER_TIME_ZONE];
      const lastTimezone = userTimeZone ? JSON.parse(userTimeZone) : {};
      const timezone = jstz.determine();
      const timezoneName = timezone.name();
      const value = { ...lastTimezone, timezone: timezoneName };
      const options: CookieSerializeOptions = {
        secure: process.env.NODE_ENV === NodeEnv.PROD,
        path: '/',
      };
      document.cookie = cookie.serialize(USER_TIME_ZONE, JSON.stringify(value), options);
    } catch (e) {
      Logger.error(e);
    }
  }, []);
};
